export enum LicenseSystemCommunicationState {
	Failed = 'FAILED',
	NotAttemped = 'NOT_ATTEMPED',
	Success = 'SUCCESS'
}
